import { getWorkCategoryIDByName } from './workCategory';

/**
 * taskに出発タスクや到着タスクが含まれているかどうかを返す。
 * @param task AllocationTask
 * @returns boolean
 */
export const isTaskStartOrArrival = (task?: {
  workCategory: { id: number };
}) => {
  return [
    getWorkCategoryIDByName('出発'),
    getWorkCategoryIDByName('到着'),
  ].includes(task?.workCategory.id);
};
